import * as types from "./mutation-type";

const RECAPTCHA_WAIT_INTERVAL_MS = 100;
const RECAPTCHA_WAIT_TIMEOUT_MS = 5000;

const hasRecaptchaClientId = () => {
    return (
        typeof grecaptcha !== "undefined" &&
        grecaptcha.clientId !== undefined &&
        grecaptcha.clientId !== null
    );
};

const isRecaptchaReady = () => {
    return (
        typeof grecaptcha !== "undefined" &&
        typeof grecaptcha.ready === "function" &&
        typeof grecaptcha.execute === "function" &&
        hasRecaptchaClientId()
    );
};

const waitForRecaptcha = (timeout = RECAPTCHA_WAIT_TIMEOUT_MS) => {
    return new Promise((resolve) => {
        if (isRecaptchaReady()) {
            resolve(true);
            return;
        }

        const startedAt = Date.now();
        const intervalId = window.setInterval(() => {
            if (isRecaptchaReady()) {
                window.clearInterval(intervalId);
                resolve(true);
                return;
            }

            if (Date.now() - startedAt >= timeout) {
                window.clearInterval(intervalId);
                resolve(false);
            }
        }, RECAPTCHA_WAIT_INTERVAL_MS);
    });
};

export const actionGetTokenRecaptcha = ({commit}, payload) => {
    return new Promise(async (resolve, reject) => {
        const recaptchaReady = await waitForRecaptcha();
        if (!recaptchaReady) {
            resolve(null)
            return
        }

        grecaptcha.ready(() => {
            grecaptcha.execute(grecaptcha.clientId)
            .then(token => {
                commit(types.SET_TOKEN, token)
                resolve(token)
            })
            .catch(reject)
        })
    })
}
